import isCopilotFeatureEnabled from "owa-copilot-settings-utils/lib/utils/isCopilotFeatureEnabled";
import getModuleContextMailboxInfo from "owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo";
import getApplicationSettings from "owa-application-settings/lib/selectors/getApplicationSettings";
import type { ComposeViewState } from "owa-mail-compose-store/lib/store/schema/ComposeViewState";
import getSmimeAdminSettings from "owa-session-store/lib/utils/getSmimeAdminSettings";
import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import getSelectedTableView from "owa-mail-list-store/lib/utils/getSelectedTableView";
import folderIdToName from "owa-session-store/lib/utils/folderIdToName";

/**
 * Returns whether Copilot Elaborate should show in the Command Center.
 * Currently, it can show in Compose and ReadOnly scenarios.
 */
export function shouldShowElaborateMenuItem(shouldIgnoreUserPreferences: boolean, viewState: ComposeViewState | undefined): boolean {
    const smimeAdminSettings = getSmimeAdminSettings() || {};
    const alwaysEncrypt = smimeAdminSettings?.AlwaysEncrypt ?? false;
    
    const isSmimeEncrypt = getUserConfiguration()?.UserOptions?.SmimeEncrypt ?? false;
    
    const isNotesFolder = folderIdToName(getSelectedTableView()?.tableQuery?.folderId ?? "") === "notes";
    
    // Elaborate has Reply/Draft (meaning non-Compose) scenarios,
    // so we only want to check for initialized state if Compose Form is active.
    if ((viewState &&
        (!viewState.draftCopilot.isInitialized ||
            viewState.smimeViewState?.shouldEncryptMessageAsSmime)) ||
        (!viewState && (alwaysEncrypt || isSmimeEncrypt)) ||
        isNotesFolder) {
        return false;
    }
    
    const mailboxInfo = getModuleContextMailboxInfo();
    const appSettings = getApplicationSettings("Copilot", mailboxInfo);
    return !!isCopilotFeatureEnabled("Elaborate", mailboxInfo, appSettings.enableMultiLanguage, shouldIgnoreUserPreferences);
}
